
import axiosSync from "@/axiosSync";

export function usePortInfoGponCDATACLODEV1Api() {
  async function getGponClodeBasicInfo(olt_id) {
    const response = await axiosSync.get(`/cdata-gpon-cloude/api?oltid=${olt_id}&url=${process.env.VUE_APP_API_BASE_URL}`);
    return response.data;
  }
  async function getGponClodePonPortData(olt_id) {
    const response = await axiosSync.get(`/cdata-gpon-cloude/api?oltid=${olt_id}&dta=portdbm&url=${process.env.VUE_APP_API_BASE_URL}`);
    return response.data;
  }
  async function getGponClodePonPortOverViewData(olt_id) {
    const response = await axiosSync.get(`/cdata-gpon-cloude/api?oltid=${olt_id}&dta=oltponportinfo&url=${process.env.VUE_APP_API_BASE_URL}`);
    return response.data;
  }
  async function getSingleOnuData(port_number, olt_id) {
    const matches = port_number.match(/(GPON|EPON)?(\d+\/\d+\/\d+):(\d+)/i);
    
if (!matches) {
    throw new Error(`Invalid port number format: ${port_number}. Expected format like GPON0/0/1:18 or EPON0/0/1:18`);
}

const pon_id = matches[2];  // "0/0/1" - the full PON path
const onu_id = matches[3];  // "18" - the ONU ID

console.log(`pon_id=${pon_id}&onu_id=${onu_id}`);
    
    // const url = `vsol-epon?type=single_onudata&pon=${ponid}&onu=${onuid}&oltid=${olt_id}&url=${process.env.VUE_APP_API_BASE_URL}`;
    const url = `/cdata-gpon-cloude/api?oltid=${olt_id}&dta=onustatus&onu_id=${onu_id}&pon_id=${pon_id}&url=${process.env.VUE_APP_API_BASE_URL}`;
    console.log('Cloud Gpon Service - API URL:', url);
    
    const response = await axiosSync.get(url);
    console.log('Cloud Gpon Service - Response received');
    
    return response.data;
}



  return {
    getGponClodeBasicInfo,
    getGponClodePonPortData,
    getGponClodePonPortOverViewData,
    getSingleOnuData
  };
}
